import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=ae05be72&scoped=true&"
import script from "./PersonDetail.vue?vue&type=script&lang=js&"
export * from "./PersonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae05be72",
  null
  
)

export default component.exports